module.exports = __webpack_public_path__ + "static/img/ic_alarm@2x.3249b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_alarm@2x.png
// module id = gPkl
// module chunks = 1